export const api_key = "CNCPDySU8Qt4AYG5zSj2";
export const scan_sdk_api_key = "CNCPDySU8Qt4AYG5zSj2";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-one-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") =>
  new URL(url, "https://sdk-one.carenow.healthcare");
// export const flyy_partner_id = "94d1585895da21a1b1ab";
